import moment from "moment";
export const formatDate = (date: Date) => {
  return moment(date).format("D-MMMM-YYYY hh:mm:ss A");
};
